import { mapGetters, mapMutations } from 'vuex';
import { planTypes, AUTO_ADD_BASE_PLAN_CODES, AUDIO_SUB_TYPES, AccountType } from '@/common/constants';
import { AddOrRemoveBasePlanActionTypes } from '../constants';
import { getPlanTotalLicense } from '@/common/service/validate';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { ONLINE_NOT_SUPPORT_BILLING_CYCLE } from '@/common/service/non-standard-billing-cycle-utils';

export default {
  data() {
    return {
      title: '',
      msgInstance: null,
      visibleCapacityList: [],
      hasModifyCapacity: false
    };
  },
  computed: {
    ...mapGetters([
      'getCurrentMeetingPlans',
      'currentEditPlan',
      'getBoughtMeetingPlans',
      'getCurrentBasePlanInfo',
      'getSelectedPlans',
      'fromCampaignLink',
      'plancodeMapSubscriptionDisabled',
      'boughtPlans',
      'basicConfig'
    ]),
    currentBasePlans() {
      return this.getCurrentMeetingPlans.length ? this.getCurrentMeetingPlans : this.getCurrentBasePlanInfo?.plans;
    },
    mx_getBoughtOrBuyingBasePlans() {
      const boughtMeetingPlans = this.getBoughtMeetingPlans;
      const {
        category: basePlanCategory,
        billing_cycle: basePlanBillingCycle,
        planNameKey,
        typeNameKey,
        type: basePlanType,
      } = boughtMeetingPlans[0] || this.currentBasePlans[0];
      const basePlanName = this.$t(planNameKey) || this.$t(typeNameKey);
      const currentBasePlanQuantity = boughtMeetingPlans[0] ? getPlanTotalLicense(boughtMeetingPlans) : 0;
      return {
        basePlanCategory,
        basePlanBillingCycle,
        basePlanType,
        basePlanName,
        planNameKey,
        typeNameKey,
        currentBasePlanQuantity,
      };
    },
    mx_currentPlans() {
      const planType = this.configPlanType === planTypes.EVENT_SAAS_CORE ? this.configPlanType : this.planType
      return this.selectedPlanList?.filter((item) => item.type === planType) || [];
    },
    mx_plansSortedByMaximumCount() {
      return this.mx_currentPlans.sort(
        (itemPrev, itemNext) => (itemNext.cartInfo?.selected_number || 0) - (itemPrev.cartInfo?.selected_number || 0),
      );
    },
    // For multiple capacities plans to pick the largest license count
    mx_peakCapacityLicenseCount() {
      const peakPlan = this.mx_plansSortedByMaximumCount[0];
      return peakPlan?.cartInfo?.selected_number || 0;
    },
    mx_planLicenseCount() {
      // could be override by specific requirement
      return this.mx_peakCapacityLicenseCount;
    },
    mx_canAutoAdd() {
      const autoAddBasePlans = this.currentBasePlans.filter((plan) =>
        AUTO_ADD_BASE_PLAN_CODES.includes(plan.plan_code),
      );
      const hasAudioUnlimited = !!this.boughtPlans.find(item => item.type === planTypes.TOLLFREE && item.category === AUDIO_SUB_TYPES.UNLIMITED);
      //isCustomPricing4MajorPlan means multiple pro/biz plan, not include single customer rate plan
      const isMultipleRatePlan = this.basicConfig?.isCustomPricing4MajorPlan;
      const isSingleRateOrSupportMultipleRate = !isMultipleRatePlan || autoAddBasePlans.every((plan) => (plan?.ratePlans?.length > 1));
      const isEnableStatus = autoAddBasePlans.every((plan) => !this.plancodeMapSubscriptionDisabled[plan.plan_code]);
      const isSpecialBillingCycle =  ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(this.currentBasePlans[0]?.billing_cycle);
      const hasMeetingPlan = this.boughtPlans.find(item => item.type === planTypes.ZOOM_MEETING)
      const isAdd = this.$config('enableAddonsAutoAddForAdd2Cart') && [flowTypes.add2cart].includes(pageConfig.type) && !isMultipleRatePlan
      && !isSpecialBillingCycle && !hasMeetingPlan
      return (
        pageConfig.accountType !== AccountType.ACCOUNT_ACTIVE_HOST &&
        this.mx_currentPlans.length &&
        this.currentBasePlans.length === 1 &&
        autoAddBasePlans.length === 1 &&
        !this.hasModifyCapacity &&
        !this.fromCampaignLink &&
        isSingleRateOrSupportMultipleRate &&
        !hasAudioUnlimited &&
        isEnableStatus
        && (isAdd || ![flowTypes.add2cart].includes(pageConfig.type))
      );
    },
  },
  created() {
    this.hasModifyCapacity = this.mx_getInitHasModifyCapacityValue();
  },
  methods: {
    ...mapMutations(['updateSelectPlanByCategory', 'setUpdateBasePlan', 'addOrRemoveBasePlan']),
    mx_getInitHasModifyCapacityValue() {
      if (
        !this.$context.is.edit ||
        !this.currentEditPlan ||
        !this.currentEditPlan.type
      ) return false;

      const currentPlan = this.mx_currentPlans.find(item => item.type === this.currentEditPlan.type);
      if (!currentPlan) return false;

      return currentPlan.category !== this.currentEditPlan.category;
    },
    mx_checkCapacityChanged(newPlan) {
      const { type: basePlanType } = this.getBoughtMeetingPlans[0] || this.currentBasePlans[0];
      this.hasModifyCapacity = newPlan.category !== this.currentEditPlan.category;
      if (this.hasModifyCapacity) {
        this.addOrRemoveBasePlan({ actionType: AddOrRemoveBasePlanActionTypes.REMOVE, planType: planTypes[basePlanType] });
      }
    },
    mx_plansFilteredByCapacityKey(capacity, capacityKey) {
      return this.mx_currentPlans.filter((item) => item[capacityKey] === capacity);
    },
    // For chosen specific capacity key license count
    mx_totalCapacityLicenseCount(capacity, capacityKey = this.capacityKey) {
      const chosenPlans = this.mx_plansFilteredByCapacityKey(capacity, capacityKey);
      return getPlanTotalLicense(chosenPlans);
    },
    mx_autoSyncSelectedNumber(basePlanCategory, basePlanBillingCycle, basePlanNewSelectorNumber) {
      this.updateSelectPlanByCategory({
        category: basePlanCategory,
        billingCycle: basePlanBillingCycle,
        cartInfo: { selected_number: basePlanNewSelectorNumber },
      });
      this.$nextTick(() => {
        this.setUpdateBasePlan({ update: true, from: this.title }); // Ensure the triggering of the watch in ZOOM_MEETING/edit.
      });
    },
    mx_onAddedBasePlan() {
      // no-op
    },
    mx_onRemovedBasePlan() {
      // no-op
    },
  },
  watch: {
    mx_planLicenseCount: {
      immediate: true,
      handler(nv) {
        if (!this.mx_canAutoAdd) return;

        const { basePlanCategory, basePlanBillingCycle, basePlanType, basePlanName, currentBasePlanQuantity } =
          this.mx_getBoughtOrBuyingBasePlans;
        if (nv > currentBasePlanQuantity) {
          if(!this.getSelectedPlans.map(e => e.type).includes(basePlanType)) {
            this.addOrRemoveBasePlan({ actionType: AddOrRemoveBasePlanActionTypes.ADD, planType: planTypes[basePlanType] });
            this.mx_onAddedBasePlan(basePlanName);
          }
          // If auto replenish selected number to base plan
          this.mx_autoSyncSelectedNumber(basePlanCategory, basePlanBillingCycle, nv);
        } else if (nv <= currentBasePlanQuantity && this.getSelectedPlans.map(e => e.type).includes(basePlanType)) {
          this.addOrRemoveBasePlan({ actionType: AddOrRemoveBasePlanActionTypes.REMOVE, planType: planTypes[basePlanType] });
          this.mx_onRemovedBasePlan(basePlanName);
        }
      },
    },
  },
};
